import React from 'react';
import classnames from 'classnames';
import formatMoney from 'utils/formatters/Money';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class PaymentSummary extends React.Component {
  render() {
    const { total, paid, balance, credit_memos, t, currency } = this.props;
    return (
      <div data-testid="div-cbeffac4" className="space-y-3">
        <div
          data-testid="div-08881ea2"
          className="flex items-center justify-between"
        >
          <span
            data-testid="dt-ab055e7a"
            className="text-sm text-muted-foreground"
          >
            {titleize(t('TOTAL'))}
          </span>
          <span data-testid="dd-4971e29e" className="font-semibold">
            {formatMoney(total, currency)}
          </span>
        </div>
        <div
          data-testid="div-61f0cb65"
          className="flex items-center justify-between"
        >
          <span
            data-testid="dt-aff0cca7"
            className="text-sm text-muted-foreground"
          >
            {titleize(t('PAID'))}
          </span>
          <span data-testid="dd-d33b7569" className="font-semibold">
            {formatMoney(paid, currency)}
          </span>
        </div>
        {credit_memos?.length > 0 && (
          <div
            data-testid="div-2c34c100"
            className="flex items-center justify-between"
          >
            <span
              data-testid="dt-8c2663fe"
              className="text-sm text-muted-foreground"
            >
              {titleize(t('CREDIT'))}
            </span>
            <span
              data-testid="dd-f1f60704"
              className={classnames('font-semibold', {
                'text-red-500': !!credit_memos?.length,
              })}
            >
              {formatMoney(
                credit_memos?.reduce(
                  (sum, memo) => sum + (memo.total || 0),
                  0,
                ) || 0,
                currency,
              )}
            </span>
          </div>
        )}
        <div
          data-testid="div-9e0901a3"
          className="flex items-center justify-between"
        >
          <span
            data-testid="dt-b76578e8"
            className="text-sm text-muted-foreground"
          >
            {titleize(t('BALANCE'))}
          </span>
          <span data-testid="dd-199f4f4e" className="font-semibold">
            {formatMoney(balance, currency)}
          </span>
        </div>
        {credit_memos?.length > 0 && (
          <div
            data-testid="div-30cd88a1"
            className="flex items-center justify-between"
          >
            <span
              data-testid="dt-dc312cb3"
              className="text-sm text-muted-foreground"
            >
              {t('CREDIT_MEMO')}
            </span>
            <span data-testid="dd-075de389" className="font-semibold">
              {credit_memos &&
                !!credit_memos.length &&
                credit_memos.map((creditMemo, index) => (
                  <React.Fragment key={creditMemo._id}>
                    <a
                      data-testid="a-db029a21"
                      href={`/invoices/${creditMemo._id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {creditMemo.number}
                    </a>
                    {index < credit_memos.length - 1 ? ', ' : ''}
                  </React.Fragment>
                ))}
            </span>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(PaymentSummary);
